import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';
import css from './UserNav.module.css';
import { useSelector } from 'react-redux';
import { getUserType } from '../../util/genericHelper';
import { USER_TYPES } from '../../util/enums';

const UserNav = props => {
  const { className, rootClassName, currentPage } = props;
  const classes = classNames(rootClassName || css.root, className);
  const { currentUser } = useSelector(state => state.user);
  const userType = getUserType(currentUser);

  let tabs = [
    {
      text: <FormattedMessage id="UserNav.yourListings" />,
      selected: currentPage === 'ManageListingsPage',
      linkProps: {
        name: 'ManageListingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.sellerSettings" />,
      selected: currentPage === 'SellerSettingsPage',
      disabled: false,
      linkProps: {
        name: 'SellerSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  // ✅ Remove "Profile Settings" for firm users
  if (userType === USER_TYPES.FIRM) {
    tabs = tabs.filter(tab => tab.linkProps.name !== 'ProfileSettingsPage');
  }
  if (userType === USER_TYPES.USER) {
    tabs = tabs.filter(tab => tab.linkProps.name !== 'SellerSettingsPage');
  }

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

export default UserNav;
